import React, {useState, useEffect} from 'react'
import logo from '../images/Logo_north.png'
import {Link, useNavigate} from 'react-router-dom'
import axios from 'axios'
import { baseURL, server_API } from '../config'
import login from '../images/login.png'
import { useSelector, useDispatch } from 'react-redux'
import { updateUserId } from '../features/userid'
import bg from '../images/Bg.png'
import { toast, ToastContainer } from 'react-toastify';
import Copyright from "../components/Copyright";
import axiosInstance from '../axiosInstance'


// 4. Remove "Total" from total applications recieved

const Login = () => {
  const navigate  = useNavigate()
  const dispatch  = useDispatch()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [checked, setChecked] = useState(false)
  const [otp1, setOtp1] = useState('')
  const [otp2, setOtp2] = useState('')
  const [otp3, setOtp3] = useState('')
  const [otp4, setOtp4] = useState('')
  const [otp5, setOtp5] = useState('')
  const [otp6, setOtp6] = useState('')
  const [invalid, setInvalid] = useState(false)
  const [otpsent, setOTPSent] = useState(false)
  const [counter, setCounter] = useState(30)
  const [isUser, setIsUser] = useState(false)
  const [verify, setVerify] = useState(false)
  


  React.useEffect(() => {
    if(otpsent == true){
        const timer =
          counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return () => clearInterval(timer);
    }
}, [counter, otpsent]);

const sendOTP = ()=>{
if(email.length>0){
  setOTPSent(true)
  axiosInstance.post(`/v2/user/genOtp/${email}`)
  .then((res)=>{
    
    toast.success(`OTP has been sent to ${email}`,{ position: "top-center", className: "dark-mode-toast" } )
  })
  .catch((err)=>{
    console.log(err)
    alert('Could not send OTP, please trye again')
  })}else{
    toast.error("Please enter the email before sending the OTP",{ position: "top-center", className: "dark-mode-toast" })
  }

}

const verifyOTP = ()=>{

  axiosInstance.get(`/v2/user/verify/${email}/${otp1+otp2+otp3+otp4+otp5+otp6}`)
  .then((res)=>{
    dispatch(updateUserId(res.data.sucess))
    axiosInstance.get(`/v2/user/getuser/${res.data.sucess}`)
    .then((response)=>{
      console.log(response)
      if(response.data.status == "sent"){
        navigate('/resetPassword',{state:{id:response.data.uuid}})
      }
      else{
        navigate('/home')
      }
    })
    .catch((err)=>{
      console.log(err)
    })
  })
  .catch((err)=>{
    console.log(err)
    setInvalid(true)
    setOtp1('')
    setOtp2('')
    setOtp3('')
    setOtp4('')
    setOtp5('')
    setOtp6('')
  })
}

  // useEffect(()=>{
  //   if(otp1 && otp2 && otp3 && otp4 && otp5 && otp6){
  //     verifyOTP()
  //   }
  // },[otp1, otp2, otp3, otp4, otp5, otp6])


  const nav = (parsedOtp)=>{
  axiosInstance.post(`/v2/user/login`,{
    email:email,
    password:password,
    otp:parsedOtp
  })
  .then((response)=>{
    console.log(response)
    dispatch(updateUserId(response.data.success))
    axiosInstance.get(`/v2/user/getuser`)
    .then((response)=>{
    
      console.log(response)
      if(response.data.status == "sent"){
        navigate('/resetPassword',{state:{id:response.data.uuid}})
      }
      else{
        navigate('/home')
      }
    })
    .catch((err)=>{
      console.log(err)
    })
  })
  .catch((error)=>{
    console.log(error)
    if (otpsent){
      setInvalid(true)
      setOtp1('')
      setOtp2('')
      setOtp3('')
      setOtp4('')
      setOtp5('')
      setOtp6('')
    }else{
      alert('Wrong email or password')
    }
  
  })  
  }
  return (
    <div  className="bg-cover min-h-screen p-5 bgGradient flex flex-col justify-between" >
      <div>

      <div className="p-2">
        <img src={logo} className="h-10 mb-10"></img>
      </div>
      <div className="my-6">
        <div className="">
        <div className="w-1/2 bg-white py-5 px-10 rounded-xl shadow-2xl mx-auto my-4">
          <div className="grid grid-cols-2">
           {
            
            (!otpsent)
            ?
          <div className="flex flex-col space-y-5">
          <div >
            <p className="font-semibold mb-2">Email</p>
            <input value={email} onChange={(e)=>{setEmail(e.target.value)}} type="email" className="w-full outline-none border-2 rounded-md px-2 py-1" placeholder="Enter your registered email"></input>
          </div>
          <div >
            <p className="font-semibold mb-2" >Password</p>
            <input value={password} type="password" onChange={(e)=>{setPassword(e.target.value)}} className="w-full outline-none border-2 rounded-md px-2 py-1" placeholder='*******'></input>
          </div>
          <div className='flex justify-between'>
              <button className=" text-blue-500 text-xs text-left cursor-pointer" onClick={()=>{sendOTP()}}>Sign in using email OTP</button>
          <Link to="/forgotPassword">
              <p className=" text-blue-500  text-xs text-left cursor-pointer">Forgot Password?</p>
            </Link>
            </div>
          <div className="flex items-start justify-start space-x-2 text-sm">
            <input type="checkbox" className="h-7" value={checked} onChange={(e)=>{setChecked(e.target.checked)}}></input>
            <p>By logging in, you agree to Northstarz.Ai <a href={`${baseURL}#/terms`} className="text-blue-500 underline">Terms of Use</a> and <a className="text-blue-500 underline" href={`${baseURL}#/privacy`}>Privacy Policy</a></p>
          </div>
          
          <div >
            <button disabled={(!(checked)&&(email)&&(password))} onClick={()=>{nav("")}} className={((checked)&&(email)&&(password))?"bg-[#148EFF] text-white w-full rounded-xl py-3":"bg-gray-400 text-white w-full rounded-xl py-3"}>Log In</button>
          </div>

          <div className="w-full flex justify-center items-center">
            <a href={`${baseURL}#/demo`}>
              <p className=" text-blue-500 underline text-xs text-center cursor-pointer">Contact us</p>
            </a>
            
          </div>
          
          </div>
          :
          <div className="flex flex-col justify-center space-y-5">
                        <div>
                            <div className="  text-left my-6  w-full  space-y-3  mb-4 flex flex-col gap-4">
                            <div >
            <p className="font-semibold mb-2">Email</p>
            <input value={email} onChange={(e)=>{setEmail(e.target.value)}} type="email" className="w-full outline-none border-2 rounded-md px-2 py-1" placeholder="Enter your registered email"></input>
          </div>

                                <div className="flex  items-start mx-auto justify-center w-full  space-x-4 ">
                                    <input type="text" name="field-1" className={invalid?"border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center":"border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp1} onChange={(e)=>{
                                        const { maxLength, value, name } = e.target
                                        const [fieldName, fieldIndex] = name.split("-");
                                        let fieldIntIndex = parseInt(fieldIndex, 10);
                                        if (value.length >= maxLength) {
 
                                            // It should not be last input field
                                            if (fieldIntIndex < 6) {
                                 
                                                // Get the next input field using it's name
                                                const nextfield = document.querySelector(
                                                    `input[name=field-${fieldIntIndex + 1}]`
                                                );
                                 
                                                // If found, focus the next field
                                                if (nextfield !== null) {
                                                    nextfield.focus();
                                                }
                                            }
                                        }
                                        setOtp1(e.target.value)}}></input>
                                    <input type="text" name="field-2" className={invalid?"border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center":"border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp2} onChange={(e)=>{
                                        const { maxLength, value, name } = e.target
                                        const [fieldName, fieldIndex] = name.split("-");
                                        let fieldIntIndex = parseInt(fieldIndex, 10);
                                        if (value.length >= maxLength) {
 
                                            // It should not be last input field
                                            if (fieldIntIndex < 6) {
                                 
                                                // Get the next input field using it's name
                                                const nextfield = document.querySelector(
                                                    `input[name=field-${fieldIntIndex + 1}]`
                                                );
                                 
                                                // If found, focus the next field
                                                if (nextfield !== null) {
                                                    nextfield.focus();
                                                }
                                            }
                                        }
                                        setOtp2(e.target.value)}}></input>
                                    <input type="text" name="field-3" className={invalid?"border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center":"border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp3} onChange={(e)=>{
                                        const { maxLength, value, name } = e.target
                                        const [fieldName, fieldIndex] = name.split("-");
                                        let fieldIntIndex = parseInt(fieldIndex, 10);
                                        if (value.length >= maxLength) {
 
                                            // It should not be last input field
                                            if (fieldIntIndex < 6) {
                                 
                                                // Get the next input field using it's name
                                                const nextfield = document.querySelector(
                                                    `input[name=field-${fieldIntIndex + 1}]`
                                                );
                                 
                                                // If found, focus the next field
                                                if (nextfield !== null) {
                                                    nextfield.focus();
                                                }
                                            }
                                        }
                                        setOtp3(e.target.value)}}></input>
                                    <input type="text" name="field-4" className={invalid?"border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center":"border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp4} onChange={(e)=>{
                                        const { maxLength, value, name } = e.target
                                        const [fieldName, fieldIndex] = name.split("-");
                                        let fieldIntIndex = parseInt(fieldIndex, 10);
                                        if (value.length >= maxLength) {
 
                                            // It should not be last input field
                                            if (fieldIntIndex < 6) {
                                 
                                                // Get the next input field using it's name
                                                const nextfield = document.querySelector(
                                                    `input[name=field-${fieldIntIndex + 1}]`
                                                );
                                 
                                                // If found, focus the next field
                                                if (nextfield !== null) {
                                                    nextfield.focus();
                                                }
                                            }
                                        }
                                        setOtp4(e.target.value)}}></input>
                                        <input type="text" name="field-5" className={invalid?"border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center":"border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp5} onChange={(e)=>{
                                        const { maxLength, value, name } = e.target
                                        const [fieldName, fieldIndex] = name.split("-");
                                        let fieldIntIndex = parseInt(fieldIndex, 10);
                                        if (value.length >= maxLength) {
 
                                            // It should not be last input field
                                            if (fieldIntIndex < 6) {
                                 
                                                // Get the next input field using it's name
                                                const nextfield = document.querySelector(
                                                    `input[name=field-${fieldIntIndex + 1}]`
                                                );
                                 
                                                // If found, focus the next field
                                                if (nextfield !== null) {
                                                    nextfield.focus();
                                                }
                                            }
                                        }
                                        setOtp5(e.target.value)}}></input>
                                        <input type="text" name="field-6" className={invalid?"border-2 text-red-500 border-red-500 outline-none w-[2rem] px-2 py-2 rounded-lg text-center":"border-2 outline-none w-[2rem] px-2 py-2 rounded-lg text-center"} maxlength="1" value={otp6} onChange={(e)=>{
                                        const { maxLength, value, name } = e.target
                                        const [fieldName, fieldIndex] = name.split("-");
                                        let fieldIntIndex = parseInt(fieldIndex, 10);
                                        if (value.length >= maxLength) {
 
                                            // It should not be last input field
                                            if (fieldIntIndex < 6) {
                                 
                                                // Get the next input field using it's name
                                                const nextfield = document.querySelector(
                                                    `input[name=field-${fieldIntIndex + 1}]`
                                                );
                                 
                                                // If found, focus the next field
                                                if (nextfield !== null) {
                                                    nextfield.focus();
                                                }
                                            }
                                        }
                                        setOtp6(e.target.value)}}></input>
                                </div>

                                <div className='flex justify-between px-4'>
              <p className=" text-blue-500 text-xs text-left cursor-pointer" onClick={()=>{setOTPSent(false); setCounter(30)}}>Sign in using password</p>
              <button disabled={counter>0} className="  text-xs text-blue-500 text-left cursor-pointer  " onClick={()=>{
                            setCounter(30)
                            sendOTP()}}>
                            {
                                counter>0? "Resend in "+
                                counter
                                :
                                "Resend OTP"
                            }
                        </button>
            </div>
          <div className="flex items-start justify-start space-x-2 text-sm">
            <input type="checkbox" className="h-7" value={checked} onChange={(e)=>{setChecked(e.target.checked)}}></input>
            <p>By logging in, you agree to Northstarz.Ai <a href={`${baseURL}#/terms`}className="text-blue-500 underline">Terms of Use</a> and <a className="text-blue-500 underline" href={`${baseURL}#/privacy`}>Privacy Policy</a></p>
          </div>
          
                                <div className="flex w-full">
                                <div className=" text-center w-full">
                                {
                                invalid &&
                                <p className="font-poppins text-sm my-3 lg:hidden block text-red-500">Invalid OTP</p>
                            }
                         <button disabled={(!(checked)&&(email))} onClick={()=>{nav(otp1+otp2+otp3+otp4+otp5+otp6)}} className={((checked)&&(email))?"bg-[#148EFF] text-white w-full rounded-xl py-3":"bg-gray-400 text-white w-full rounded-xl py-3"}>Verify</button>
                        </div>
                       
                                </div>
                            </div>
                            {
                                invalid &&
                                <p className="font-poppins text-sm my-3 hidden lg:block text-red-500">Invalid OTP</p>
                            }
                            <p className='text-center text-sm font-poppins my-3'>Please enter the 6 digit OTP sent to your registered email for authentication</p>
                        </div>
                        
          </div>
          }
          

          <div>
            <img src={login}></img>
          </div>
          </div>
        </div>
        
        </div>
      </div>
      </div>
      <div>
        <Copyright/>
      </div>
       <ToastContainer />
    </div>
  )
}

export default Login